/* eslint-disable camelcase */
import update from 'immutability-helper';
import { get as getId } from '../../localId/localId';
import { API_CREATE_WORK_ORDER_SUCCESS, API_LOAD_WORK_ORDER_LOADED } from '../workOrders.reducer';

export const SAVE_MATERIAL = 'SAVE_MATERIAL';
export const ADD_LOCAL_MATERIAL = 'ADD_LOCAL_MATERIAL';
export const REMOVE_LOCAL_MATERIAL = 'REMOVE_LOCAL_MATERIAL';
export const API_REMOVE_MATERIAL = 'API_REMOVE_MATERIAL';
export const API_CREATE_MATERIAL = 'API_CREATE_MATERIAL';
export const API_UPDATE_MATERIAL = 'API_UPDATE_MATERIAL';
export const MATERIAL_SET_ERROR = 'MATERIAL_SET_ERROR';
export const MATERIAL_UNSET_ERRORS = 'MATERIAL_UNSET_ERRORS';
export const MATERIAL_SET_NONE = 'MATERIAL_SET_NONE';

const API_CREATE_MATERIAL_SUCCESS = 'API_CREATE_MATERIAL_SUCCESS';
const API_UPDATE_MATERIAL_SUCCESS = 'API_UPDATE_MATERIAL_SUCCESS';
const API_REMOVE_MATERIAL_FAILED = 'API_REMOVE_MATERIAL_FAILED';
const API_REMOVE_MATERIAL_SUCCESS = 'API_REMOVE_MATERIAL_SUCCESS';
const API_REMOVE_MATERIAL_LOADING = 'API_REMOVE_MATERIAL_LOADING';

const defaultState = { materials: {} };
const emptyMaterial = workorder_id => ({ id: getId(), workorder_id, dirty: true });

// eslint-disable-next-line object-curly-newline
export const reducer = (state = defaultState, { type, response, replaceId, resource, id, workOrderId }) => {
  switch (type) {
    case MATERIAL_SET_ERROR:
      return update(state, { error: { $set: 'You must either add a material or select "No Materials."' } });
    case MATERIAL_UNSET_ERRORS:
      return update(state, { $unset: ['error'] });
    case SAVE_MATERIAL:
      return update(state, { materials: { [resource.id]: { $set: { ...emptyMaterial(), ...resource } } } });
    case API_LOAD_WORK_ORDER_LOADED:
      return update(state, { materials: { $set: response.materials.reduce((obj, next) => Object.assign(obj, { [next.id]: next }), {}) } });
    case ADD_LOCAL_MATERIAL:
      const timesheet = emptyMaterial(workOrderId);
      return update(state, { materials: { [timesheet.id]: { $set: timesheet } } });
    case API_REMOVE_MATERIAL_SUCCESS:
    case REMOVE_LOCAL_MATERIAL:
      return update(state, { materials: { $unset: [id] } });
    case API_REMOVE_MATERIAL_FAILED:
      return update(state, { materials: { [id]: { removing: { $set: false } } } });
    case API_REMOVE_MATERIAL_LOADING:
      return update(state, { materials: { [id]: { removing: { $set: true } } } });
    case API_CREATE_MATERIAL_SUCCESS:
      return update(state, { materials: { [response.id]: { $set: response }, $unset: [replaceId] } });
    case API_UPDATE_MATERIAL_SUCCESS:
      return update(state, { materials: { [response.id]: { $set: response } } });
    case API_CREATE_WORK_ORDER_SUCCESS:
      return Object.keys(state.materials).reduce((s, eId) => update(s, { materials: { [eId]: { workorder_id: { $set: response.id } } } }), state);
    default:
      return state;
  }
};

export const materials = (workOrderId, state) => Object.values(state.materials.materials).filter(o => o.workorder_id.toString() === workOrderId.toString());
export const dirtyMaterials = state => Object.values(state.materials.materials).filter(o => o.dirty);
export const areDirtyMaterials = state => dirtyMaterials(state).length > 0;
export const error = state => state.materials.error;

export default reducer;



// WEBPACK FOOTER //
// ./src/reducers/workOrder/material/material.reducer.js